import * as React from 'react';
import { CredentialSecret } from '../../../../types';
import { useTrashablePromise } from '../../../../hooks';
import { apiRawFetch } from '../../../../APIClient';

// TODO: integrate with useLazyAuthQuery some day

export const useFetchCredentials = () => {
  const [credentials, setCredentials] = React.useState<CredentialSecret[]>([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState<any>(null);

  const { registerPromise } = useTrashablePromise();

  const getCredentialsLists = React.useCallback(async () => {
    setError(null);
    setIsLoading(true);
    try {
      const { credentials: accounts } = await registerPromise(
        apiRawFetch.listCredentials(),
      );
      setCredentials(accounts);
      setIsLoading(false);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [registerPromise]);

  React.useEffect(() => {
    getCredentialsLists();
  }, [getCredentialsLists]);

  return {
    error,
    isLoading,
    credentials,
    getCredentialsLists,
  };
};
